import React from 'react';

export const Plus = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => {
	return (
		<svg width='18' height='17' viewBox='0 0 18 17' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<path
				d='M9 1V16M16.5 8.5L1.5 8.5'
				stroke={props.fill}
				strokeWidth={1.5}
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};
